module.exports = {"540126100":"德庆镇","540126200":"塔杰乡","540126201":"章多乡","540126202":"唐嘎乡","540126203":"雪乡","540126204":"帮堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540126.json
// module id = 2681
// module chunks = 0